import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const Implement: FunctionComponent<Props> = ({ children, className = '' }) => (
    <div className={`${className} ${styles.implement}`}>
        <div className={styles.content}>This feature is coming soon</div>

        {children}
    </div>
);

export default Implement;
